import React, {useState} from 'react';
import {IRoom, IUser} from '../../Constants/Interfaces';
import {useDispatch} from 'react-redux';
import {Dispatch} from '../../Redux/store';
import classNames from 'classnames';
import {Icon} from '@iconify/react';

import './List.sass';
import {Chat} from '../Chat/Chat';
import {Wrapper} from '../Wrapper/Wrapper';
import {INotifications} from '../../Messages';


interface IUserListProps {
    rooms: IRoom[];
    selectedId: string;
    users: IUser[];
    notifications: INotifications;
}


export const RoomList: React.FC<IUserListProps> = ({
    rooms,
    selectedId,
    notifications,
    users,
}) => {

    const [collapsed, setCollapsed] = useState<boolean>(false);

    const {messages: {handleRoomSelect}} = useDispatch<Dispatch>();


    function handleSelect(id: string): void {
        const selectedRoom = rooms.find((room) => room.id === id);
        if (!selectedRoom) {
            return;
        }
        handleRoomSelect(id);
    }


    return (
        <div className={classNames('mvc-list', {collapsed})}>
            <div className={'mvc-list-header'}>

                <input
                    className={'mvc-list-header-input'}
                    placeholder={`Rooms`}
                    disabled={true}
                />

                <Icon
                    icon={'eva:arrow-ios-downward-fill'}
                    height={16}
                    onClick={() => setCollapsed(!collapsed)}
                    className={'mvc-list-header-right-icon'}/>
            </div>
            <div style={{maxHeight: 220, overflow: 'scroll'}}>
                {rooms
                    .map((room, i) => {

                        const selected = selectedId === room.id;


                        const usersOnline = users.filter((user) => user.online);

                        const onlineUsersInCurrentRoom
                            = room.id === 'metaverse'
                            ? usersOnline.length
                            : usersOnline.filter((user) => user.currentlyOn === room.id).length;

                        return <Wrapper
                            key={i}
                            selected={selected}
                            expandable={false}
                            onClick={() => handleSelect(room.id)}>
                            <Chat
                                notification={!selected ? notifications[room.id] : undefined}
                                avatar_type={'room'}
                                avatar_url={room.avatar}
                                name={room.title}
                                selected={selected}
                                status_text={room.status || `${onlineUsersInCurrentRoom} online`}/>
                        </Wrapper>;
                    })}
            </div>
        </div>
    );
};

